// Types the API produces for managers and secretaries (MED-1646). Older rows
// may carry an uppercase type (e.g. "PAYMENT"); see normalizeNotification.
export const NOTIFICATION_TYPES = ["appointment", "payment", "licence"] as const;

export type NotificationType = (typeof NOTIFICATION_TYPES)[number];

export type NotificationPriority = "low" | "medium" | "high";

export interface AppNotification {
  id: number;
  userId: number;
  // A known NotificationType, or any other string the UI shows with a generic icon.
  type: NotificationType | (string & {});
  priority: NotificationPriority;
  title: string;
  message: string;
  metadata?: string;
  isRead: boolean;
  createdAt: string;
  updatedAt?: string;
}

export const normalizeNotification = (
  notification: AppNotification
): AppNotification => ({
  ...notification,
  type: (notification.type ?? "").toLowerCase(),
  // The API sends LOW / MEDIUM / HIGH; keys and filters are lowercase (MED-1649).
  priority: (notification.priority ?? "").toLowerCase() as NotificationPriority,
});
